import styled, { CSSProperties } from 'styled-components';
import { Text } from './Text';
import { GridRow } from './Grid';
import { FlexCol, FlexRowMiddle } from './Flex';
import { theme } from '../../theme/theme';

export const panelHeaderTop = '1.5rem';
export const tablePaddingSide = '2rem';

const StyledTH = styled(FlexRowMiddle)`
	width: 100%;
	overflow: hidden;
	p {
		white-space: nowrap;
		overflow: hidden;
		flex-shrink: 1;
		text-overflow: ellipsis;
	}
`;
export function TH(props: { children?: React.ReactNode; style?: CSSProperties }) {
	const { children, style, ...rest } = props;

	return (
		<StyledTH style={style && style} {...rest}>
			<Text $color="text_title_main" $size="1.3rem" $weight="500">
				{children}
			</Text>
		</StyledTH>
	);
}

const StyledTableHead = styled(GridRow)<{ $columns: string }>`
	width: min-content;
	min-width: 100%;
	padding: 1.5rem ${tablePaddingSide};
	display: grid;
	column-gap: 1.5rem;
	grid-template-columns: ${({ $columns }) => $columns};
	grid-template-rows: 1fr;

	background-color: ${({ theme }) => theme.table_head_bg};
	border-bottom: 2px solid ${({ theme }) => theme.table_head_border};
`;
export function TableHead(props: { children: React.ReactNode; columns: string; style?: CSSProperties }) {
	const { children, columns, ...rest } = props;
	return (
		<StyledTableHead $columns={columns} {...rest}>
			{children}
		</StyledTableHead>
	);
}

const StyledTable = styled(FlexCol)`
	overflow-x: auto;
`;
export function Table(props: { children: React.ReactNode; style?: CSSProperties }) {
	const { children, ...rest } = props;
	return <StyledTable {...rest}>{children}</StyledTable>;
}
export const TableBody = styled(FlexCol)<{ $loading?: boolean }>`
	width: min-content;
	min-width: 100%;
	position: relative;
	> div {
		opacity: ${({ $loading }) => ($loading ? 0.4 : 1)};
	}
`;

export const TableRow = styled(GridRow)<{
	$columns: string;
	$highlighted?: boolean;
	$hoverEnabled?: boolean;
	$customBG?: keyof typeof theme;
}>`
	width: min-content;
	min-width: 100%;
	padding: 0 ${tablePaddingSide};

	column-gap: 1.5rem;

	flex-shrink: 0;
	align-items: center;

	border-bottom: 1px solid ${({ theme }) => theme.table_head_border};

	grid-template-columns: ${({ $columns }) => $columns};
	grid-template-rows: 1fr;

	background-color: ${({ theme, $highlighted, $customBG }) =>
		$highlighted ? theme[$customBG ?? 'table_row_bg'] : 'transparent'};

	&:hover {
		background-color: ${({ theme, $hoverEnabled, $highlighted, $customBG }) =>
			$highlighted ? theme[$customBG ?? 'table_row_bg'] : $hoverEnabled ? theme.table_row_bg_hover : 'initial'};
	}
`;

export const TD = styled(FlexRowMiddle)`
	height: 100%;
	align-items: center;
	overflow: hidden;
	column-gap: 1rem;
	* {
		flex-shrink: 1;
	}
	> p {
		padding: ${panelHeaderTop} 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
